<template>
  <el-dialog
      title="发放分红"
      :visible.sync="visible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="beforeCloseHandle">
    <el-form ref="shareMoneyFormRef" :model="shareMoneyForm" :rules="shareMoneyFormRules" label-width="80px">
      <el-form-item label="发放金额" prop="balance">
        <el-input type="number" class="inp" v-model.trim.number="shareMoneyForm.balance" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item label="发放日期">
        <el-date-picker
            class="date"
            v-model="shareMoneyForm.publishDate"
            :picker-options="pickerOptions0"
            type="date"
            size="small"
            :clearable="true"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="beforeCloseHandle">取 消</el-button>
      <el-button type="primary" @click="shareMoney">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "balancepool-sharemoney",
  data(){
    var checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('金额不能为空'));
      }
      let regex=/^(0|([1-9][0-9]*))(\.[0-9]{1,2})?$/;
      console.log(typeof value);
      if(!regex.test(value) || value<=0){
        callback(new Error('请输入合法的金额'));
      }
      callback();
    }
    return {
      visible:false,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() <= Date.now()
        }
      },
      shareMoneyForm:{
        balance:"",
        publishDate:""
      },
      shareMoneyFormRules:{
        balance:[
          { required: true, message: '请输入分红金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    init(){
      this.visible=true;
    },
    beforeCloseHandle(){
      const that=this;
      that.$refs.shareMoneyFormRef.resetFields();
      that.visible=false;
      that.shareMoneyForm.publishDate="";
    },
    shareMoney(){
      const that=this;
      that.$refs['shareMoneyFormRef'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$confirm('是否确定发放分红?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$http['post']('/cp/balancepool/sharemoney', that.shareMoneyForm).then(({ data: res }) => {
            if (res.code !== 0) {
              return that.$message.error(res.msg)
            }
            that.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                that.beforeCloseHandle();
                that.$emit('refreshDataList')
              }
            })
          }).catch(() => {})
        });
      })
    }
  }

}
</script>

<style lang="css" scoped>
.inp,.date{
  width:80%;
}
</style>
